import { SortType } from "fe-common/graphql";
import { isProduction } from "../utils/envGetter";

export const featureFlagMap = require("./featureFlags.json");

export const useQueryParams = () =>
  new URLSearchParams(window?.location?.search);

export enum DebugLevel {
  Error = 1,
  Warning,
  Info,
  Verbose,
}

export enum SolverFlags {
  PathOptionsFlags = "PathOptions",
  ConversationOptionsFlags = "ConversationOptions",
}

export const SOLVER_OPTIONS = [
  SolverFlags.PathOptionsFlags,
  SolverFlags.ConversationOptionsFlags,
];

export type FeatureFlagValue =
  | boolean
  | string
  | DebugLevel
  | number
  | SortType;

const KEY_FEATURES_SETTINGS = "kahun.features-settings";

const getFeatureFlagQueryParamKey = (feature) => `FF_${feature}`;

/***
 * @deprecated use settings.makeConfigObjectForKey(
 *       FontEndFeatureFlags,
 *       ConfigSubObjectKeys.fe,
 * ) to read client feature flags
 * @param feature name of feature flags
 * @param externalDefaults overrides on external defualts (like clinic)
 */
export function getFeatureFlags(
  feature: string,
  externalDefaults = {},
): FeatureFlagValue {
  if (!isProduction()) {
    console.warn(
      `getFeatureFlags(${feature}) is deprecated! please use makeConfigObjectForKey("fe").${feature} instead`,
    );
  }
  const queryParams = useQueryParams();

  const fromQueryParam = queryParams.has(getFeatureFlagQueryParamKey(feature));

  const ffValue = queryParams.get(getFeatureFlagQueryParamKey(feature));

  if (ffValue === "true" || ffValue === "false") {
    return ffValue === "true";
  }

  if (fromQueryParam) {
    // If thats not a boolean just parse it
    try {
      return JSON.parse(ffValue);
    } catch (e) {
      // If we failed just return a string
      return ffValue;
    }
  }

  const featuresMapConfig = featureFlagMap[process.env.REACT_APP_ENVIRONMENT];

  const localFeaturesMap = JSON.parse(
    localStorage.getItem(KEY_FEATURES_SETTINGS),
  );

  const featuresMap = {
    ...featuresMapConfig,
    ...externalDefaults, // Used for clinic defaults to allow local storage overrides
    ...localFeaturesMap,
  };

  return featuresMap && (featuresMap[feature] as FeatureFlagValue);
}

export function getSolverFlags(group: SolverFlags, externalFlags?: any): any {
  const featuresMap = {
    ...(JSON.parse(localStorage?.getItem(KEY_FEATURES_SETTINGS) || null) || {}),
    ...(externalFlags || {}),
  };

  return Object.entries(featuresMap).reduce((acc, [feature, value]) => {
    if (feature.includes(group)) {
      // if it is a json valid string, convert it, else its a simple string
      if (typeof value === "string")
        try {
          value = JSON.parse(value);
        } catch {
          /** its not json, no problem */
        }

      acc[feature.replace(`${group}_`, "")] = value;
    }

    return acc;
  }, {});
}
